import React from 'react';
import { VideoOffHoc, VideoOnHoc, AudioOffHoc, AudioOnHoc, RejectCallHoc } from '../../assets/images';
import { store } from '../../Redux/store';
import "./CallControlButtons.scss";

const CallControlButtons = (props)=>{
    const { 
        handleEndCall,
        cssClassName,
        videoMute, 
        audioMute,
        audioControl,            
        videoControl
    } = props

    const handleAudioMute = (e) => {
        const { callLogData:{ data: { callAudioMute = false } = {}} = {} } = store.getState();
        e.stopPropagation();
        props.handleAudioMute(!callAudioMute);
    }

    const handleVideoMute = (e) => {
        e.stopPropagation();
        props.handleVideoMute(!videoMute);
    }

    let { videoPermissionDisabled } = props;

    return (
        <div className="caling-button-group button-group-center">
            {audioControl &&
                <span className={`${cssClassName}  ${audioMute ? "mute" : ""}`} title="Mute / Unmute" onClick={handleAudioMute} >
                    <i className={audioMute ? "audioBtn mute" : "audioBtn "}>
                        {audioMute ? <AudioOffHoc viewBox="0 0 19.144 20.207"/> : <AudioOnHoc  viewBox="0 0 10.765 14.609"/>}
                    </i>
                </span> 
            } 
            <span title="Hangup" className="btnHangup rejectCall" onClick={handleEndCall}><i><RejectCallHoc viewBox="0 0 32 32"/></i></span>
            {videoControl &&
                <span className={`${cssClassName}  ${videoMute ? "mute" : ""} ${videoPermissionDisabled ? "not-allowed" : ""} `} title={videoPermissionDisabled ? "Camera Permission Disabled" : "Start / Stop Camera"} onClick={videoPermissionDisabled ? undefined : handleVideoMute}>
                <i className={videoMute ? "videoBtn mute" : "videoBtn"}>
                        {videoMute ? <VideoOffHoc viewBox="0 0 13.802 12.882"/> : <VideoOnHoc viewBox="0 0 15.071 9.545"/>}
                    </i>
                </span>
            } 
        </div>
    )
}

export default CallControlButtons;
